export default "__VITE_ASSET__CrQUc7Po__"